export default "__VITE_ASSET__B67uD2SP__"